module.exports = __webpack_public_path__ + "img/sidebar_sp2.png";